import { createAction } from 'redux-starter-kit';
import * as api from 'api/auth';

import { asyncGetUserInfo, asyncGetPaymentInfo } from 'actions/user';

export const login = createAction('auth/LOGIN');
export const loginSuccess = createAction('auth/LOGIN_SUCCESS');
export const loginFailure = createAction('auth/LOGIN_FAILURE');

export const register = createAction('auth/REGISTER');
export const registerSuccess = createAction('auth/REGISTER_SUCCESS');
export const registerFailure = createAction('auth/REGISTER_FAILURE');

export const logout = createAction('auth/LOGOUT');

export const initForgotPassword = createAction('auth/FORGOT_PASSWORD_INITI');
export const forgotPassword = createAction('auth/FORGOT_PASSWORD');
export const forgotPasswordSuccess = createAction('auth/FORGOT_PASSWORD_SUCCESS');
export const forgotPasswordFailure = createAction('auth/FORGOT_PASSWORD_FAILURE');
export const resetPassword = createAction('auth/RESET_PASSWORD');
export const resetPasswordSuccess = createAction('auth/RESET_PASSWORD_SUCCESS');
export const resetPasswordFailure = createAction('auth/RESET_PASSWORD_FAILURE');

export const redirectTo = createAction('auth/REDIRECT_TO');

export const asyncLogin = (email, password, rememberMe) => async dispatch => {
  dispatch(login());
  api
    .login(email, password)
    .then(data => {
      dispatch(
        loginSuccess({
          token: data,
          rememberMe
        })
      );
      dispatch(asyncGetUserInfo());
      dispatch(asyncGetPaymentInfo());
    })
    .catch(err => {
      dispatch(loginFailure({ error: err.message }));
    });
};

export const asyncRegister = (first_name, last_name, email, password, password_confirmation) => async dispatch => {
  dispatch(register());
  api
    .register(first_name, last_name, email, password, password_confirmation)
    .then(data => {
      dispatch(registerSuccess(data));
      dispatch(asyncGetUserInfo());
    })
    .catch(err => {
      dispatch(registerFailure({ error: err.message }));
    });
};

export const asyncLogout = () => async dispatch => {
  api.logout().then(data => {
    dispatch(logout());
    window.location.reload();
  });
};

export const asyncForgotPassword = email => async dispatch => {
  dispatch(forgotPassword());
  api
    .forgotPassword(email)
    .then(data => {
      dispatch(forgotPasswordSuccess(data));
    })
    .catch(err => {
      dispatch(forgotPasswordFailure({ error: err.message }));
    });
};
export const asyncResetPassword = (token, email, password, password_confirmation) => async dispatch => {
  dispatch(resetPassword());
  api
    .resetPassword(token, email, password, password_confirmation)
    .then(data => {
      dispatch(resetPasswordSuccess(data));
    })
    .catch(err => {
      dispatch(resetPasswordFailure({ error: err.message }));
    });
};
